import {
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useBoxes,
    useStorageItemValue
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useMemo} from "react";
import {Box} from "@variocube/app-api";
import {useLocalization} from "../../i18n";


export interface BoxTabProps {
    onOpen: (box: Box) => void;
}

export function BoxTab({onOpen}: BoxTabProps) {
    const boxes = useBoxes();

    return (
        <BoxTable
            boxes={boxes || []}
            onOpen={onOpen}
        />
    );
}

export interface BoxTableProps {
    boxes: Box[];
    onOpen: (box: Box) => void;
}

export function BoxTable({boxes, onOpen}: BoxTableProps) {
    const {t} = useLocalization();

    const plasticBagBoxes = useStorageItemValue<string[]>("plasticBagBoxes");
    const bigBagBoxes = useStorageItemValue<string[]>("bigBagBoxes");
    const wasteBoxes = useStorageItemValue<string[]>("wasteBoxes");

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell width="5%">{t("Box")}</TableCell>
                    <TableCell>{t("Content")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {boxes.map(box =>
                        <BoxRow
                            key={box.number}
                            box={box}
                            onOpen={onOpen}
                            plasticBagBoxes={plasticBagBoxes || []}
                            bigBagBoxes={bigBagBoxes || []}
                            wasteBoxes={wasteBoxes || []}
                        />
                )}
            </TableBody>
        </Table>
    );
}

export interface BoxRowProps {
    box: Box;
    onOpen: (box: Box) => void;
    plasticBagBoxes: string[];
    bigBagBoxes: string[];
    wasteBoxes: string[];
}

export function BoxRow({box, onOpen, plasticBagBoxes, bigBagBoxes, wasteBoxes}: BoxRowProps) {
    const handleClick = useCallback(() => onOpen(box), [onOpen, box]);

    const boxContent = useMemo<string|null>(() => {
        if(plasticBagBoxes.includes(box.number)) {
            return "Plastic Bags";
        }
        if(bigBagBoxes.includes(box.number)) {
            return "Big Bags";
        }
        if(wasteBoxes.includes(box.number)) {
            return "Waste";
        }
        return null;
    }, [plasticBagBoxes, bigBagBoxes, wasteBoxes]);

    return (
        <TableRow onClick={handleClick}>
            <TableCell>
                <Avatar size={1.5}>{box.number}</Avatar>
            </TableCell>
            <TableCell>{boxContent}</TableCell>
        </TableRow>
    );
}
